<template>
  <div class="profile-completeness-notification">
    <p v-translate :class="notificationClasses.title" class="paragraph-bold">
      Oh no! Looks like your profile is not visible to employers yet.
    </p>
    <highlighted-text-block>
      <div v-translate :class="notificationClasses.text">
        Complete your profile to make it visible to employers. This will give
        you a much higher chance of being interviewed, and help our Talent Advisor to bring out the very best in you.
      </div>
    </highlighted-text-block>
    <router-link v-translate v-if="routeOfUncompletedRequiredPart" :to="routeOfUncompletedRequiredPart" class="button is-secondary paragraph-m is-rounded ">
      Complete my profile
    </router-link>
  </div>
</template>

<script>

import HighlightedTextBlock from 'top20common/components/text-blocks/HighlightedTextBlock';
import {mapGetters} from 'vuex';

import profileParts from '@/services/profile-parts';

export default {
  computed: {
    ...mapGetters(['profileDetailsState']),
    notificationClasses() {
      return {
        title: this.$mq.desktop ? 'paragraph-l' : 'paragraph-s',
        text: this.$mq.desktop ? 'paragraph' : 'paragraph-s'
      };
    },
    routeOfUncompletedRequiredPart() {
      return {name: profileParts.getUncompletedRequiredPartRouteName(this.profileDetailsState.profile_completeness)};
    }
  },
  components: {
    HighlightedTextBlock
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

.profile-completeness-notification {
  p {
    padding-bottom: 15px;
  }

  /deep/ .paragraph-highlighted {
    margin-bottom: 25px;
  }

  /deep/ .text-highlighted {
    padding: 5px 20px;
  }

  .button {
    margin-bottom: 36px;
  }
}

@media screen and (max-width: $tablet) {
  .profile-completeness-notification {
    /deep/ .paragraph-highlighted {
      margin-left: -24px;
    }
  }
}
</style>
